import { render, staticRenderFns } from "./warehouseSys.vue?vue&type=template&id=a36c48ce"
import script from "./warehouseSys.vue?vue&type=script&lang=js"
export * from "./warehouseSys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports